<template>
  <div class="main-wrapper gallery-page innerpagebg">
    <layouts-header v-if="!authStore.user"></layouts-header>
    <user-header v-if="authStore.user"></user-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />

    <div class="content gallery-blk">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2>Danh mục hình ảnh</h2>
            <div class="category-list">
              <div
                class="category-item"
                v-for="(category, index) in categories"
                :key="index"
                @click="openCategory(category.list_files)"
                data-aos="fade-down"
              >
                <img :src="category.thumbnail" class="thumbnail" alt="Category" />
                <h3 class="category-title">{{ category.title }}</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Lightbox hiển thị ảnh -->
    <vue-easy-lightbox 
      :visible="visible"
      :index="index"
      :imgs="currentImages"
      @hide="visible = false"
      @on-prev="handlePrev"
      @on-next="handleNext"
    />

    <layout-footer></layout-footer>
  </div>
</template>

<script>
import axios from "axios";
import VueEasyLightbox from "vue-easy-lightbox";
import { useAuthStore } from "@/stores/auth";
import { getGalleries } from "@/api/strapi/gallery";
import { getImageUrl } from "@/api/strapi/image";

export default {
  components: {
    VueEasyLightbox,
  },
  data() {
    const authStore = useAuthStore();
    return {
      authStore,
      title: "Hình ảnh",
      text: "Trang chủ",
      text1: "Hình ảnh",
      visible: false,
      index: 0,
      currentImages: [],
      categories: [],
      authStore
    };
  },
  async created() {
    await this.fetchGallery();
  },
  methods: {
    async fetchGallery() {
      try {
        const response = await getGalleries();
        this.categories = response.data.map((item) => {
          return {
            id: item.id,
            title: item.title,
            description: item.description,
            thumbnail: item.thumbnail?.url 
              ? getImageUrl(item.thumbnail.url)
              : "",
            list_files: item.list_files
              ? item.list_files.map(file => ({
                  src: getImageUrl(file.url),
                }))
              : [],
            };
        });
        console.log('dữ liệu', this.categories);
      } catch (error) {
        console.error("Lỗi lấy dữ liệu gallery:", error);
      }
    },
    openCategory(images) {
      this.currentImages = images;
      this.index = 0;
      this.visible = true;
    },
    handlePrev(oldIndex, newIndex) {
      this.index = newIndex;
    },
    handleNext(oldIndex, newIndex) {
      this.index = newIndex;
    },
  },
};
</script>

<style scoped>
h {
  text-align: center;
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
}

.category-title {
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  color: #222;
  margin-top: 0px;
}

.category-description {
  font-size: 1rem;
  color: #666;
  text-align: center;
  max-width: 80%; 
  margin: 10px auto;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
